import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/base/base.service';
import { AdminCatalogModel } from 'src/app/model/admin/catalog';

@Injectable({
  providedIn: 'root'
})
export class DoctorSpecialtiesDialogService extends BaseService {

  constructor(
    protected store: Store<any>
  ) {
    super();
  }

  readSpecialtiesStore = (): Observable<AdminCatalogModel[]> =>
    this.store.select('admin', 'catalog', 'subCatalogs', 'spe')

}
